import { render } from "./WrapMenu.vue?vue&type=template&id=cbada006&scoped=true"
import script from "./WrapMenu.vue?vue&type=script&lang=js"
export * from "./WrapMenu.vue?vue&type=script&lang=js"

import "./WrapMenu.vue?vue&type=style&index=0&id=cbada006&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cbada006"

export default script